module.exports = __webpack_public_path__ + "static/media/36569e0c28df6d844450d25e40a29929.63edea7a.png";